import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetAccessUserManualLink,
	GetAccessUserManualLinkModel,
	GetAccessUserManualLinkParams,
} from 'domain/usecases/private/external-links/user-manual/get-access-user-manual';

export class RemoteGetAccessUserManualLink implements GetAccessUserManualLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAccessUserManualLinkModel>,
	) {}

	async get(params?: GetAccessUserManualLinkParams): Promise<GetAccessUserManualLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
